import './button.css'

const button = ({children}) => (

    <button className="button_btn">{children}</button>
);

export default button;